import React, { useMemo, useState } from 'react'
import { FormattedDate } from 'react-intl'

import { addDays } from 'date-fns'
import styled from 'styled-components/native'

import { ProviderDashboardCard } from '@lyrahealth-inc/ui-core-crossplatform/src/organisms/providerDashboardCard/ProviderDashboardCard'

import AgendaContent from './AgendaContent'
import { actions as mixpanelActions, mixpanelEvents } from '../../../../mixpanel/mixpanelConstants'
import { track } from '../../../../mixpanel/mixpanelTracking'

const ProviderCard = styled(ProviderDashboardCard)({
  maxWidth: '413px',
  flex: 1,
  maxHeight: '100%',
})

const Agenda: React.FC = () => {
  const today = useMemo(() => new Date(), [])
  const tomorrow = useMemo(() => addDays(today, 1), [today])
  const [activeDate, setActiveDate] = useState(today)

  return (
    <ProviderCard
      title={<FormattedDate value={activeDate} weekday='long' month='short' day='numeric' />}
      onTabChange={(id) => {
        const date = id === 'tomorrow' ? 'tomorrow' : 'today'
        track({
          event: mixpanelEvents.BUTTON_PRESS,
          action: mixpanelActions.AGENDA_DATE_SELECT,
          properties: { date },
        })
        setActiveDate(date === 'tomorrow' ? tomorrow : today)
      }}
      tabs={[
        {
          id: 'today',
          label: 'Today',
          content: <AgendaContent date={today} />,
        },
        {
          id: 'tomorrow',
          label: 'Tomorrow',
          content: <AgendaContent date={tomorrow} />,
        },
      ]}
    />
  )
}

export default Agenda
